export function parseFee(fee) {
  if (!fee) return 0
  const currencyMatches = [...fee.matchAll(/(?:₹|Rs\.?)\s?([\d,.]+)/gi)]
  if (currencyMatches.length) {
    return Math.max(...currencyMatches.map(m => {
      const num = parseFloat(m[1].replace(/,/g, ''))
      return isNaN(num) ? 0 : num
    }))
  }
  const num = parseFloat(fee.replace(/[^0-9.]/g, ''))
  return isNaN(num) ? 0 : num
}
